// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__220LI","col":"styles_col__1HlZp"};